<template>
	<div class="operation_box">
		<div class="operation_item">
			<md-button :class="{ 'md-primary': hasRowsAllowingInterested }" :disabled="!hasRowsAllowingInterested" @click="approveSelected()">
				{{ $t("marketSoundingDecision.button.interested") }}
			</md-button>
		</div>
		<div class="operation_item">
			<md-button :class="{ 'md-block': hasRowsAllowingNotInterested }" :disabled="!hasRowsAllowingNotInterested" @click="rejectSelected()">
				{{ $t("marketSoundingDecision.button.notInterested") }}
			</md-button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		setInterestedAllSelected: { type: Function },
		setNotInterestedAllSelected: { type: Function }
	},
	data() {
		return {
			selectedRows: []
		}
	},
	created() {
		// Listen to selection of rows and reloading of the table which clears the selection but does not call the event
		this.params.api.addEventListener('selectionChanged', this.onSelectionChanged);
		this.params.api.addEventListener('rowDataChanged', this.onSelectionChanged);
	},
	destroyed() {
		this.params.api.removeEventListener('selectionChanged', this.onSelectionChanged);
		this.params.api.removeEventListener('rowDataChanged', this.onSelectionChanged);
	},
	computed: {
		hasRowsAllowingInterested() {
			return this.selectedRows.some(data => data.allowSetInterestedGetter());
		},
		hasRowsAllowingNotInterested() {
			return this.selectedRows.some(data => data.allowSetNotInterestedGetter());
		}
	},
	methods: {
		onSelectionChanged() {
			this.selectedRows = this.params.api.getSelectedRows();
		},
		approveSelected() {
			// Check validity again, since the opportunities could have expired for example
			let selectedRowsAllowingInterested = this.selectedRows.filter(data => data.allowSetInterestedGetter());

			this.params.setInterestedAllSelected(selectedRowsAllowingInterested);
		},
		rejectSelected() {
			// Check validity again, since the opportunities could have expired for example
			let selectedRowsAllowingNotInterested = this.selectedRows.filter(data => data.allowSetNotInterestedGetter());

			this.params.setNotInterestedAllSelected(selectedRowsAllowingNotInterested);
		}
	}
};
</script>
